import {Component} from 'react';
import PropTypes from 'prop-types';

export default class ScrollPosition extends Component {
    static propTypes = {
        position: PropTypes.number.isRequired,
    };

    static defaultProps = {
        position: 0
    };

    componentDidMount() {
        this.scrollToPosition(this.props);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.position !== this.props.position) {
            this.scrollToPosition(nextProps)
        }
    }

    scrollToPosition = ({position}) => {
        window.scrollTo(0, position || 0);
    };

    render() {
        return false;
    }
}



// WEBPACK FOOTER //
// ./src/components/ScrollPosition.js